export default {
  createAnAccount: 'Створити аккаунт',
  createNewAccount: 'створіть новий аккаунт',
  forgotYourPasswordQuestion: 'Забули свій пароль?',
  signIn: 'Увійти',
  signUp: 'Зареєструватися',
  signInToYourAccount: 'увійдіть до свого аккаунту'
};
